import React from 'react'
import PropTypes from 'prop-types'
import {Col, Row} from 'react-grid-system'
import {useFormik} from 'formik'
import {useTranslation} from 'react-i18next'
import {useNavigate, useParams} from 'react-router-dom'

import {Spinner} from 'pyrexx-react-library'
import Navigator from '../../Navigator/Navigator'
import {useSearchParams} from "react-router-dom";
import {gql, useQuery} from "@apollo/client";
import isObjectValid from "../../../helper/isObjectValid";
import ModalPopup from "../../ModalPopup/ModalPopup";
import {
  StyledWelcome
} from "../../../routes/AppointmentSchedule/AppointmentSchedule.styles";

const GET_APPOINTMENT_BY_ID = gql`
  query AppointmentByIdWithNonce($encryptedAppointmentId: String!, $code: String!) {
    GetAppointmentInformationWithNonce(encryptedAppointmentId: $encryptedAppointmentId, code: $code) {
      validation {
        success
        message
        messageType
      }
      serviceCategory
      street
      zip
      town
      floor
      lastName
      firstName
      companyName
      callOutCharge
    }
  }
`
const IndividualAppointmentPlanningMessage = (props) => {
  const {savedValues = {}, saveFormInputs, nextStep} = props
  const [search] = useSearchParams()
  const {t} = useTranslation()
  const navigate = useNavigate()

  let {appointmentId, code} = useParams();
  if(appointmentId === undefined) {
    appointmentId = search.get('appointmentId') || '';
  }

  if(code === undefined) {
    code = search.get('code') || '';
  }
  const formik = useFormik({
    initialValues: {
      appointmentId: appointmentId,
      code: code,
    },
    onSubmit: (values) => {
      saveFormInputs(values)
      navigate(nextStep)
    },
  })

  const variables = {
    encryptedAppointmentId: appointmentId,
    code: code,
  }

  let errorMessage = ''

  const {data, loading, error} = useQuery(GET_APPOINTMENT_BY_ID, {
    variables,
    fetchPolicy: 'no-cache',
  })

  if (loading) return <Spinner/>
  if (error) {
    errorMessage = t(
      'SOMETHING WENT WRONG, PLEASE TRY AGAIN LATER OR CONTACT THE SUPPORT',
    )
  }

  const tfs = data?.GetAppointmentInformationWithNonce || {}

  const {
    validation,
    street,
    zip,
    town,
    floor,
    firstName,
    lastName,
    serviceCategory,
    companyName,
    callOutCharge
  } = tfs

  savedValues.street = street
  savedValues.zip = zip
  savedValues.town = town
  savedValues.floor = floor
  savedValues.firstName = firstName
  savedValues.lastName = lastName
  savedValues.serviceCategory = serviceCategory
  savedValues.companyName = companyName
  savedValues.callOutCharge = callOutCharge

  if (!errorMessage && !isObjectValid(tfs)) {
    errorMessage = t(
      'SOMETHING WENT WRONG, PLEASE TRY AGAIN LATER OR CONTACT THE SUPPORT',
    )
  }

  if (!errorMessage && !validation.success) {
    if(validation.messageType === 'User'){
      errorMessage = validation.message
    }else{
      errorMessage = t(
        'SOMETHING WENT WRONG, PLEASE TRY AGAIN LATER OR CONTACT THE SUPPORT',
      )
    }
  }

  if (errorMessage) {
    return (
      <ModalPopup
        isOpen
        showButtonClose={false}
        noteText={<p>{errorMessage}</p>}
        handleModalClose={() => {
        }}
        onClick={() => navigate('/')}
        buttonText={t('CLOSE')}
      />
    )
  } else {
    return (
      <form onSubmit={formik.handleSubmit}>
        <Row justify='center'>
          <Col>

            <StyledWelcome>
              {t(`DEAR RESIDENT,

YOU HAVE MISSED ALL THE REGULAR MAINTENANCE APPOINTMENTS FOR YOUR SMOKE ALARM. IT IS MANDATORY THAT YOU MAKE AN INDIVIDUAL APPOINTMENT FOR THIS IMPORTANT MAINTENANCE.
PLEASE NOTE THAT FAILURE TO COMPLY WITH REGULAR MAINTENANCE MAY RESULT IN ADDITIONAL COSTS UP TO {CALL_OUT_CHARGE} EUR. HOWEVER, THE DECISION TO CHARGE THESE COSTS IS AT THE DISCRETION OF THE PROPERTY MANAGER.
YOU CAN EASILY SCHEDULE AN APPOINTMENT FOR REQUIRED MAINTENANCE ON THE FOLLOWING PAGES.
THANK YOU FOR YOUR COOPERATION IN ENSURING THE SAFETY AND WELL-BEING OF ALL RESIDENTS.

BEST REGARDS,
YOUR PYREXX TEAM`, {
                CALL_OUT_CHARGE: savedValues.callOutCharge,
              })}

            </StyledWelcome>

          </Col>
        </Row>

        <Navigator nextButtonText={t('SELECT SLOTS')} />
      </form>
    )
  }
}

IndividualAppointmentPlanningMessage.propTypes = {
  savedValues: PropTypes.object,
  saveFormInputs: PropTypes.func.isRequired,
  prevStep: PropTypes.string,
  nextStep: PropTypes.string,
}

export default IndividualAppointmentPlanningMessage
